import { Controller } from "stimulus";

// Container types only apply to a container-level milestone, so the select is
// locked while that checkbox is clear.
//
// Moved out of an inline <script> in the milestone form: inline script is
// blocked by a Content-Security-Policy without 'unsafe-inline' (SHP-17632).
// The logic is unchanged from the inline version.
export default class extends Controller {
  static targets = ["level", "types", "wrapper"];

  connect() {
    // The inline version this replaced opened with the same bail-out. Stimulus
    // throws on a missing target rather than returning null, so without it a
    // form rendered without either field would fail to connect at all and the
    // checkbox would silently stop working.
    if (!this.hasLevelTarget || !this.hasTypesTarget) {
      return;
    }

    // A disabled multi-select is not posted at all, which would leave
    // previously-saved container types in place. This hidden field guarantees an
    // empty container_type_ids is submitted while the select is locked, so a
    // save clears them.
    this.clearField = document.createElement("input");
    this.clearField.type = "hidden";
    this.clearField.name = "milestone[container_type_ids][]";
    this.clearField.value = "";
    this.clearField.disabled = true;

    const form = this.typesTarget.form;
    if (form) {
      form.appendChild(this.clearField);
    }

    this.toggle();
  }

  disconnect() {
    if (this.clearField) {
      this.clearField.remove();
    }
  }

  toggle() {
    if (!this.hasLevelTarget || !this.hasTypesTarget) {
      return;
    }

    const enabled = this.levelTarget.checked;

    if (!enabled) {
      Array.prototype.forEach.call(this.typesTarget.options, (option) => {
        option.selected = false;
      });
    }

    // Locked with pointer-events rather than `disabled` so the field still
    // submits; only the empty clear field is submitted while locked.
    this.typesTarget.style.pointerEvents = enabled ? "" : "none";
    if (this.hasWrapperTarget) {
      this.wrapperTarget.style.opacity = enabled ? "" : "0.5";
    }
    if (this.clearField) {
      this.clearField.disabled = enabled;
    }

    // Keep any select-enhancement UI (e.g. select2) in sync if attached later.
    this.typesTarget.dispatchEvent(new Event("change"));
  }
}
